import Icon, { BaseIconProps } from './react-components/Icon'

/**
 * Renders the generated SVG icon HappyManHoldingATeaCupIcon as a React component.
 * These icons are rendered with special wrapper helpers via our internal <Icon> component,
 * which is built on top of MUI's <SvgIcon> component.
 * If you're experiencing rendering issues, contact the UIPT team or consult the docs
 * for the underlying components. Do not modify this icon directly. It is a generated file.
 */ const HappyManHoldingATeaCupIcon = (props: BaseIconProps) => {
  return (
    <Icon {...props} nativeViewbox="0 0 124 113">
      <path
        d="M123.63 73.3254C123.63 106.876 97.9795 112.226 63.84 112.226C29.7005 112.226 0 106.876 0 73.3254C0 39.7745 27.6755 12.5762 61.815 12.5762C95.9545 12.5762 123.63 39.7745 123.63 73.3254Z"
        fill="#96D7D2"
      />
      <path
        d="M30.6347 64.3383C25.4464 73.9026 22.2487 93.8501 21.2073 106.364C22.2731 107.963 32.4276 111.366 39.8583 111.267C39.5206 109.385 40.2328 70.9422 42.2031 52.6494C40.3454 53.4419 34.7723 56.7108 30.6347 64.3383Z"
        fill="#05518D"
      />
      <path
        d="M97.5177 108.709L90.1366 53.2434C77.6769 46.4058 67.848 42.1394 47.991 49.3769C45.1874 50.6258 42.6862 51.1615 38.9498 54.334C37.7018 55.3936 35.7807 66.1639 35.2318 71.6841C34.3847 80.2042 34.0319 85.5912 34.1161 90.2238C34.302 100.448 34.6893 104.977 35.5961 111.054C35.5961 111.054 40.7622 112.118 44.1223 112.333C78.2686 114.52 97.5177 108.709 97.5177 108.709Z"
        fill="#FFC832"
      />
      <path
        d="M70.9875 50.1033C62.0721 52.4863 55.2087 50.1364 54.112 48.8125C49.3571 59.7742 48.7581 98.8717 50.6685 112.872C51.1638 112.938 52.7282 113.284 72.2611 112.458C70.4568 101.834 67.5912 86.146 70.9875 50.1033Z"
        fill="white"
      />
      <path
        d="M55.6134 52.5586C54.846 52.047 50.7108 51.6672 48.4727 51.5962C47.1931 51.5962 48.521 50.0047 50.6036 48.0823C53.3746 45.5245 55.5068 44.0292 61.6883 42.7502C67.8698 41.4713 72.7724 43.2831 74.7973 45.6278C76.4173 47.5036 78.0302 51.383 78.6341 53.0883C76.1118 53.2659 70.5982 53.5785 68.7224 53.408C60.4094 55.2198 56.5726 53.1981 55.6134 52.5586Z"
        fill="#0F69AF"
      />
      <path
        d="M48.1696 30.3748C48.5107 25.7706 51.7933 15.7381 53.3919 11.2974C64.9024 8.95267 79.982 16.259 80.4083 17.9643C80.7494 19.3285 76.5715 24.9984 74.44 27.6628C75.6123 27.4497 76.2668 27.6533 76.5715 27.7694C78.8097 28.622 79.3425 32.3128 76.5715 34.0575C74.44 35.3996 72.2018 34.8035 71.2426 34.8035C70.4966 39.4929 70.6576 49.3456 70.8708 54.3547C61.4919 57.8505 55.6302 54.9586 53.9249 53.0758C54.1736 52.8271 54.9363 51.6854 55.3626 51.0033C55.8955 50.1507 58.0853 47.1074 57.5524 42.5246C52.3301 42.0983 47.7433 36.1299 48.1696 30.3748Z"
        fill="#FFCFA8"
      />
      <path
        d="M53.9299 84.0832C47.7488 81.8694 46.6688 73.2885 46.4718 68.6762C46.4171 67.3939 47.1556 66.6206 48.9211 65.7094C51.9633 64.1393 65.443 63.4474 69.7295 66.5173C70.6127 67.1498 70.6557 68.2923 70.6127 68.9706C70.2201 75.1531 67.8656 80.4523 66.3929 81.9243C64.8647 83.4518 60.5056 86.4384 53.9299 84.0832Z"
        fill="#EB3C96"
      />
      <path
        d="M68.8245 66.959C59.8797 64.0655 51.9038 65.6396 48.1067 67.1377C47.7013 67.2976 47.7243 67.8446 48.1366 67.9855C57.6131 71.224 66.1952 69.0401 68.9315 67.8448C69.4594 67.6142 69.3726 67.1363 68.8245 66.959Z"
        fill="#FEF8EB"
      />
      <path
        d="M73.1379 94.3209C73.5642 94.662 74.7365 96.8788 75.2694 97.9446L77.4008 101.248L86.6731 91.2302C86.46 90.9815 85.2663 89.7594 82.1969 86.8605C78.3601 83.2369 78.1596 83.8262 79.7192 77.5883C80.5719 74.1778 74.4962 69.1686 70.2331 68.6357C66.5029 68.6357 66.7431 71.6199 67.3826 72.366C63.759 73.2186 64.7984 75.883 65.1181 76.9488C62.3471 79.0803 63.4391 81.9579 64.0786 82.704C62.7997 83.45 63.1201 85.7947 63.7596 86.4342C64.3336 87.0081 65.6508 87.3934 66.8233 88.0329C66.8233 90.1644 68.9223 92.8161 69.7273 93.2552C70.8996 93.8946 72.605 93.8946 73.1379 94.3209Z"
        fill="#FFCFA8"
      />
      <path
        d="M63.3067 83.5566C63.7685 84.3027 65.1185 85.6882 66.1843 86.3277C67.1597 86.9129 67.8536 86.8961 67.9957 86.9671C68.3154 88.2816 69.3385 91.145 70.8733 92.0828C72.408 93.0207 73.6443 93.1841 74.0706 93.1486L73.7513 94.4275C73.6092 94.392 73.4316 94.4275 73.0048 94.321C72.7736 94.2632 70.6606 93.6815 70.1277 93.4684C69.5948 93.2552 67.5694 91.7631 67.0365 89.4184C66.8773 88.7181 66.7924 88.3129 66.7541 88.0986C66.1865 87.7677 64.9813 87.1628 64.2659 86.754C63.2693 86.1845 63.1997 85.2619 63.1997 84.6224C63.1997 84.1108 63.2711 83.6632 63.3067 83.5566Z"
        fill="#EFB279"
      />
      <path
        d="M70.5532 94.5557C72.4377 88.9037 77.2274 79.862 79.3867 76.0476C80.0597 76.3461 82.9162 80.3761 83.236 80.6746C79.3867 56.3976 83.236 52.9152 86.5376 51.3701C88.9213 51.8013 95.0822 56.4766 98.7362 65.7985C103.027 76.7441 108.427 104.015 96.8013 109.88C85.3598 115.651 74.8438 102.019 70.5532 94.5557Z"
        fill="#0F69AF"
      />
      <path
        d="M58.5413 14.6011C54.9603 15.1979 51.449 11.7537 50.5196 10.7643C47.2158 7.24727 49.0269 1.31446 49.3467 0C50.1638 0.568414 54.7833 3.51706 58.7261 3.51706C63.3693 3.51706 64.2682 3.41048 71.3022 2.45127C80.5384 1.19174 83.587 9.05907 84.2265 10.7643C84.866 12.4696 84.6234 16.4129 83.3739 18.4379C82.7481 19.452 80.3613 24.2997 76.5245 26.8575C72.6877 29.4154 73.2206 27.9233 72.6877 26.8575C72.3903 26.2627 71.3022 23.7668 71.8351 20.676C72.7934 15.1175 76.2332 14.8143 72.2898 16.4129C68.3464 18.0116 67.4938 15.2406 66.0017 13.6419C64.5096 12.0432 63.0175 13.8551 58.5413 14.6011Z"
        fill="#503291"
      />
      <path
        d="M81.7441 65.332C81.7441 65.332 90.4124 91.1948 94.9597 101.675L83.6009 87.6067C80.6616 76.5227 81.7441 65.332 81.7441 65.332Z"
        fill="#05518D"
      />
      <path
        d="M67.7592 39.4336C64.1625 42.098 59.5 42.7375 57.5547 42.5243C57.7678 44.3362 57.6801 45.3328 57.3415 46.5743C56.7021 48.919 56.4889 49.3453 54.9968 51.69C57.1639 50.5887 64.434 47.2777 67.7592 39.4336Z"
        fill="#EFB279"
      />
      <path
        d="M57.7373 61.2647C60.1812 65.4258 59.3174 68.1356 58.58 68.9704C58.7556 69.131 59.4946 69.3499 60.4761 68.3925C63.0434 65.8882 63.1487 62.8059 62.0562 60.1089C61.1349 57.8346 60.16 57.0266 58.58 52.9811C57.316 49.7447 59.2863 43.3811 59.9884 41.6152C59.1458 42.1932 56.3468 46.046 55.4198 48.743C54.261 52.1142 54.6824 56.0634 57.7373 61.2647Z"
        fill="#FBEBEB"
        fillOpacity={0.8}
      />
      <path
        d="M54.4063 16.4544C52.8689 16.6653 51.8288 17.9162 51.7986 18.1272C53.5621 17.841 57.0021 18.6305 57.5598 18.4949C58.0059 18.3864 57.8763 17.5354 57.7558 17.1234C57.4242 16.9324 55.6362 16.2857 54.4063 16.4544Z"
        fill="#503291"
      />
      <path
        d="M65.9511 19.397C67.294 20.1884 68.4357 22.4531 68.3823 22.6723C66.8589 21.7208 62.4102 20.026 61.9458 19.6807C61.5743 19.4045 62.0224 18.6159 62.2928 18.2561C62.6736 18.194 64.8767 18.7638 65.9511 19.397Z"
        fill="#503291"
      />
      <path
        d="M51.5358 22.5363C51.5358 22.5363 51.7923 21.6765 52.1276 21.1886C52.3189 20.9101 52.6207 20.4629 52.6207 20.4629L52.1276 22.5363C52.2262 22.6399 52.601 22.9302 53.311 23.262C54.0211 23.5937 54.8232 23.6766 56.0725 23.4693C55.9081 23.5384 57.0192 23.3656 55.2835 23.7803C53.5477 24.195 51.6673 23.1237 50.9441 22.5363H51.5358Z"
        fill="#503291"
      />
      <path
        d="M60.9857 24.6681C60.9857 24.6681 61.273 23.8083 61.6485 23.3204C61.8628 23.0419 62.2008 22.5947 62.2008 22.5947L61.6485 24.6681C61.7589 24.7718 62.1787 25.0621 62.974 25.3938C63.7693 25.7255 64.6677 25.8085 66.0668 25.6011C65.8827 25.6702 67.1272 25.4975 65.1831 25.9121C63.2391 26.3268 61.133 25.2556 60.323 24.6681H60.9857Z"
        fill="#503291"
      />
      <path
        d="M59.2599 30.2677L54.9968 28.8822L58.4602 21.6407L55.956 28.1361L59.2599 30.2677Z"
        fill="#EFB279"
      />
      <path
        d="M63.7326 33.0367C59.8106 34.9977 56.8034 33.5564 55.6319 32.8236C54.78 32.2907 54.4176 31.0211 57.9773 32.293C59.4688 32.8259 61.4937 33.463 63.7326 33.0367Z"
        fill="white"
      />
      <path
        d="M56.4578 34.3184C56.8566 34.903 58.1058 35.1061 60.4188 35.3569C58.6715 36.2841 57.1172 37.0291 56.4578 34.3184Z"
        fill="#EFB279"
      />
    </Icon>
  )
}
export default HappyManHoldingATeaCupIcon
